'use client';

import { setAuthCookieAction } from '@insta-club/action';
import { ApiKeys, fetcher } from '@insta-club/api';
import { ArrowIcon } from '@insta-club/components';
import { useCustomForm } from '@insta-club/hooks';
import { useSessionStore } from '@insta-club/state';
import { Button, Form, Input } from '@insta-club/ui';
import { SignUpFormValues, SignUpSchema } from '@insta-club/validator';
import { useRouter, useSearchParams } from 'next/navigation';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';
import PssswordInput from 'src/libs/ui/input/password';

function SignUpForm() {
    const router = useRouter();
    const searchParams = useSearchParams();
    const username = searchParams.get('username');
    const verification_code = searchParams.get('verification_code');

    const form = useCustomForm(SignUpSchema);
    const onSubmit: SubmitHandler<SignUpFormValues> = async (data) => {
        let res: {
            message: boolean;
            token: string;
            status: number;
        } | null = null;

        res = await fetcher(ApiKeys.REGISTER, 'web', 'POST', {
            body: {
                ...data,
                username,
                verification_code
            }
        });

        if (res?.token) {
            const cookie = await setAuthCookieAction(res?.token);
            if (cookie?.success) {
                useSessionStore.getState().updateSession();
                router.push('/dashboard');
            } else {
                toast.error(cookie.error ?? 'مشکلی پیش آمده');
            }

            toast.success('ثبت نام با موفقیت انجام شد.');
        }
    };

    return (
        <Form form={form} onSubmit={onSubmit}>
            <div className='flex flex-col gap-6'>
                <Input name='first_name' inputType='text' label='نام' />
                <Input name='last_name' inputType='text' label='نام خانوادگی' />
                <PssswordInput name='password' inputType='text' label='رمز عبور' />
                <PssswordInput name='password_confirmation' inputType='text' label='تکرار رمز عبور' />
                <Button
                    loading={form.formState.isSubmitting}
                    type='submit'
                    size='lg'
                    fullWidth
                    icon={<ArrowIcon className='rotate-180 text-white' />}
                    iconPosition='end'
                >
                    <span className='text-base font-semibold'>ذخیره اطلاعات</span>
                </Button>
            </div>
        </Form>
    );
}

export default SignUpForm;

